import type { Permissions } from '@/rbac/grants'
import type { Role } from '@/stores/auth'
import { isDemoDeployment } from '@/utils/deployment'
import { apiCall } from './axiosInstance'
import { rolesApi as demoRolesApi } from './demo/rolesApi'

const v3RolesApi = {
	getRoles: async (tenantId?: string): Promise<Role[]> => {
		const res = await apiCall<{ roles: Role[] }>(
			'/v3/roles',
			tenantId
				? {
						headers: {
							'x-bytebeam-tenant': tenantId,
							'x-bytebeam-impersonate': 'admin',
						},
					}
				: undefined,
		)
		return res.roles ?? []
	},
	getRolesForOrganization: async (organizationId: string): Promise<Record<string, Role[]>> => {
		const res = await apiCall<{
			roles: Array<{ tenant_id: string; name: string; permissions?: Permissions }>
		}>(`/v3/organizations/${encodeURIComponent(organizationId)}/roles`)

		const grouped: Record<string, Role[]> = {}
		for (const role of res.roles ?? []) {
			grouped[role.tenant_id] ??= []
			grouped[role.tenant_id].push({
				name: role.name,
				permissions: role.permissions,
			})
		}

		return grouped
	},
	createRole: async (role: { name: string; permissions: Permissions }): Promise<{ status: string; name: string }> =>
		apiCall('/v3/roles', { method: 'POST', data: role }),
	updateRole: async (
		roleName: string,
		updateObj: {
			new_name?: string
			permissions?: Permissions
		},
	): Promise<{ status: string }> =>
		apiCall('/v3/roles', {
			method: 'PATCH',
			data: {
				name: roleName,
				...updateObj,
			},
		}),
	deleteRole: async (roleName: string): Promise<{ status: string }> =>
		apiCall('/v3/roles', {
			method: 'DELETE',
			data: {
				name: roleName,
			},
		}),
}

export const rolesApi = isDemoDeployment() ? demoRolesApi : v3RolesApi
